import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sendSupportChatMessage } from './request';
import { supportChatKeys } from '@/api/queries/support-chat/key';
import type { SendSupportChatMessagePayload } from '@/types';

export const useSendSupportChatMessage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: SendSupportChatMessagePayload) =>
      sendSupportChatMessage(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: supportChatKeys.conversation(),
      });
    },
  });
};
